import Vue from 'vue';
import App from './App.vue';
import i18n from '@/plugins/i18n';
import router from './router';
import store from './stores';
import VueGoogleApi from '@/plugins/google-api';
import * as VueGoogleMaps from 'vue2-google-maps';
import vueHeap from '@/plugins/heap-analytics';
import { vueApolloProvider } from '@/services/ApolloDefaultClient';
import VueI18nFilter from 'vue-i18n-filter';
import VueObserveVisibility from 'vue-observe-visibility';
import './filters';
import { Loading } from 'element-ui';
import linkify from 'vue-linkify';

// plugins
import VueHotjar from '@/plugins/hotjar';

// css
import '@/assets/css/tailwind.css';

// https://github.com/phanan/vue-linkify
Vue.directive('linkified', linkify);

// loading
Vue.use(Loading.directive, { fullscreen: true });
Vue.prototype.$loading = Loading.service;

Vue.config.productionTip = false;

Vue.use(VueGoogleApi);
Vue.use(VueI18nFilter);
Vue.use(VueObserveVisibility);

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
    libraries: 'places' // This is required if you use the Autocomplete plugin
  },

  /// / If you want to manually install components, e.g.
  /// / import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  /// / Vue.component('GmapMarker', GmapMarker)
  /// / then set installComponents to 'false'.
  /// / If you want to automatically install all the components this property must be set to 'true':
  installComponents: false
});

if (process.env.NODE_ENV !== 'development') {
  Vue.use(vueHeap, process.env.VUE_APP_HEAP);
  Vue.use(VueHotjar, { id: process.env.VUE_APP_HOTJAR_ID, sv: process.env.VUE_APP_HOTJAR_SV });
}

new Vue({
  i18n,
  router,
  store,
  apolloProvider: vueApolloProvider,
  render: h => h(App)
}).$mount('#app');
